import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es')

/** *
* *Generates Concursant reports
@param plays Plays data
@param action Defines if it saves it or dislpays it
@param sort  Group plays by genre or not
@param addCountry  boolean to show country column
@param country country to show
@param author oolean to show author column
*/
const generatePDFPlay = (plays,action,sort = false,addCountry=false,country = '',author=true) => { 
  // initialize jsPDF
  const doc = new jsPDF('p', 'mm','a4',true);

  // define the columns we want and their titles
  var tableColumn = []
  if(author)
    tableColumn = ["Número", "Título", "Autor(es)", "Género", "Fecha",];
  else
    tableColumn = ["Número", "Título", "Seudónimo", "Género", "Fecha",];
  if (addCountry){
    tableColumn.push('País')
  }
  let headP = [
    [
        {content: 'Poesía',  colSpan: 5,styles: {halign: 'center', fillColor: [22, 160, 133]}}, 
    ],
    tableColumn,
  ];
  let headN = [
  [
      {content: 'Novela', colSpan: 5, styles: {halign: 'center', fillColor: [22, 160, 133]}}, 
  ],
  tableColumn,
  ];
  let headE = [
  [
      {content: 'Ensayo Histórico Social',colSpan: 5,  styles: {halign: 'center', fillColor: [22, 160, 133]}}, 
  ],
  tableColumn,
  ];

  // define an empty array of rows
  const tableRows = [];
  const tableRowsP = [];
  const tableRowsN = [];
  const tableRowsE = [];

  // for each play pass all its data into an array
  plays.forEach(play => {
    const playData = author ? [
        play.code,
        play.title,
        play.authorStr,
        play.category,
        play.date,
    ]:
    [
      play.code,
      play.title,
      play.pseudo,
      play.category,
      play.date,
    ];
    // push each play's info into a row

    if(addCountry){
      playData.push(country)
    }
    if(play.category === 'Poesía'){
      tableRowsP.push(playData)
    }
    else if(play.category === 'Novela'){
      tableRowsN.push(playData)
    }
    else {
      tableRowsE.push(playData)
    }
    tableRows.push(playData);
  });


  // startY is basically margin-top
  moment.locale('es')
  var today = moment(Date.now())

 
  // we use a date string to generate our filename.
  const date = Date().split(" ");
  const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
 
  // we define the name of our PDF file.
  doc.text(`Premio Casa de las Americas 2022`, 55, 15);
  doc.text(`${today.format('LL')}`, 80, 25);
  doc.text("Reporte de Obras", 8, 30);

  if(sort){
    doc.autoTable({ startY: 35,head:headP, body:tableRowsP });
    doc.addPage();
    doc.autoTable({ startY: 35,head:headN, body:tableRowsN });
    doc.addPage();
    doc.autoTable({ startY: 35,head:headE, body:tableRowsE });
  }
  else{
    doc.autoTable(tableColumn, tableRows, { startY: 35 });
  }

  if(action === "save"){
    doc.save(`reporte_obras_${dateStr}.pdf`);
  }
  else{
    
      doc.output('dataurlnewwindow',{"filename":"reporte_obras.pdf"});
  }
};

export default generatePDFPlay;